import { render, staticRenderFns } from "./aiAsk.vue?vue&type=template&id=33446f2a&scoped=true&"
import script from "./aiAsk.vue?vue&type=script&lang=js&"
export * from "./aiAsk.vue?vue&type=script&lang=js&"
import style0 from "./aiAsk.vue?vue&type=style&index=0&id=33446f2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33446f2a",
  null
  
)

export default component.exports